import React from "react";
import { Helmet } from "react-helmet-async";
import "./DigitalStrategyConsultation.css";


// Images for services
import StrategyHeroImg from "../assets/strategy-hero.jpeg";



const DigitalStrategyConsultation = () => {
  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp CTA",
        value: 1,
      });
    }
  };

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Digital Strategy & Consultation Services in Kenya | Satima Technova Solutions</title>

<link rel="canonical" href="https://satimatechnova.co.ke/digital-strategy-consultation/" />

        <meta
          name="description"
          content="Professional digital strategy and consultation in Kenya. Satima Technova Solutions helps businesses, SMEs, and startups develop actionable digital plans, optimize marketing channels, and achieve measurable growth."
        />

        <meta
          name="keywords"
          content="digital strategy Kenya, strategy consultation Kenya, business growth Kenya, marketing strategy Kenya, digital planning Kenya, SEO consultation Kenya, content strategy Kenya, Satima Technova Solutions"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Digital Strategy & Consultation Services in Kenya" />
        <meta property="og:description" content="Get expert digital strategy and consultation services to grow your business online in Kenya." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/digital-strategy-consultation/" />


        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How much does digital strategy consultation cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our digital strategy consultation is charged based on the time required to analyze your business, understand your goals, and provide practical recommendations. The consultation rate is KSh 1,000 per hour. During the consultation, we review your current digital presence, identify growth opportunities, and provide actionable strategies to help your business move forward."
      }
    },
    {
      "@type": "Question",
      "name": "What businesses need digital strategy consultation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Digital strategy consultation is ideal for startups, SMEs, professional service providers, e-commerce businesses, and companies looking to improve their online visibility and growth."
      }
    },
    {
      "@type": "Question",
      "name": "What is included in a digital strategy consultation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our consultation includes analyzing your current digital presence, identifying opportunities, reviewing marketing channels, providing recommendations, and creating a practical growth roadmap."
      }
    },
    {
      "@type": "Question",
      "name": "How long does a consultation take?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The consultation duration depends on your business needs and the level of analysis required. Most sessions cover your goals, challenges, current digital presence, and recommended next steps."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide marketing recommendations after consultation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. After analyzing your business, we provide practical recommendations covering areas such as SEO, social media marketing, content strategy, advertising, and website improvements."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help improve my existing online presence?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We review your existing website, social media platforms, and digital marketing efforts to identify areas that can be improved for better visibility and customer engagement."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact Satima Technova Solutions for a consultation. We will understand your business goals, evaluate your current digital position, and recommend the right strategy to help you grow."
      }
    }
  ]
})}
</script>



      </Helmet>

      <main className="strategy-page">

        {/* TRUST SCROLLING BAR */}

<section className="ds-trust-scroll">

  <div className="ds-trust-track">


    <div className="ds-trust-content">

      <span>✓ Business Growth Strategy</span>

      <span>✓ Data-Driven Decisions</span>

      <span>✓ Digital Transformation</span>

      <span>✓ Expert Consultation</span>

    </div>



    <div className="ds-trust-content">

      <span>✓ Business Growth Strategy</span>

      <span>✓ Data-Driven Decisions</span>

      <span>✓ Digital Transformation</span>

      <span>✓ Expert Consultation</span>

    </div>


  </div>

</section>


{/* HERO SECTION */}

<section
  className="ds-hero-section"
  style={{
    backgroundImage: `url(${StrategyHeroImg})`
  }}
>
  <div className="ds-hero-overlay">

    <div className="ds-hero-wrapper">

      <div className="ds-hero-text">

        {/* SEO H1 - HIDDEN VISUALLY */}

        <h1 className="ds-hidden-heading">
          Digital Strategy & Consultation Services in Kenya That Drive Growth
        </h1>


        {/* HERO CONTENT */}

        <div className="ds-intro-content">

          <span className="ds-hero-tag">
            DIGITAL STRATEGY & CONSULTATION
          </span>

          <h2>
            Strategy With
            <br />
            <span>Direction.</span>
          </h2>

          <p className="ds-intro-line">
            We help businesses turn digital opportunities into clear
            strategies that support visibility, customers, and growth.
          </p>

        </div>


        {/* CTA */}

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20your%20digital%20strategy%20and%20consultation%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="ds-hero-cta"
        >
          Talk To A Strategy Expert
        </a>


        {/* TRUST POINTS */}

        <div className="ds-trust-points">

          <p>
            <span>01</span>
            Business-focused planning
          </p>

          <p>
            <span>02</span>
            Data-driven strategies
          </p>

          <p>
            <span>03</span>
            Aligned with your goals
          </p>

        </div>

      </div>

    </div>

  </div>
</section>


{/* DIGITAL STRATEGY GAP */}
<section className="ds-gap-section">

  <div className="ds-gap-container">

    {/* SECTION HEADER */}
    <div className="ds-gap-header">

      <span className="ds-gap-label">
        THE DIGITAL GAP
      </span>

      <h2>
        Your Business Doesn't Need
        <br />
        <span>More Digital Activity.</span>
      </h2>

      <p>
        It needs the right direction.
      </p>

    </div>


    {/* MAIN CONTENT */}
    <div className="ds-gap-content">

      {/* LEFT SIDE */}
      <div className="ds-gap-statement">

        <span className="ds-gap-number">
          01
        </span>

        <h3>
          Having the pieces
          <br />
          <span>isn't enough.</span>
        </h3>

        <p>
          A business may have a website, social media,
          advertising, SEO, and content. But when these
          activities are not connected to a clear objective,
          they can quickly become disconnected efforts.
        </p>

      </div>


      {/* RIGHT SIDE */}
      <div className="ds-gap-explanation">

        <div className="ds-gap-item">

          <span>01</span>

          <div>
            <h4>More activity</h4>

            <p>
              More channels, more content, and more campaigns
              do not automatically create better results.
            </p>
          </div>

        </div>


        <div className="ds-gap-item">

          <span>02</span>

          <div>
            <h4>Less clarity</h4>

            <p>
              Without clear priorities, it becomes difficult
              to know what deserves attention or investment.
            </p>
          </div>

        </div>


        <div className="ds-gap-item">

          <span>03</span>

          <div>
            <h4>Disconnected efforts</h4>

            <p>
              Your website, marketing, content, and social
              presence can end up working independently.
            </p>
          </div>

        </div>


        <div className="ds-gap-item">

          <span>04</span>

          <div>
            <h4>Difficult to measure</h4>

            <p>
              When there is no clear objective, it becomes
              harder to understand what is actually working.
            </p>
          </div>

        </div>

      </div>

    </div>


    {/* CLOSING STATEMENT */}
    <div className="ds-gap-closing">

      <span className="ds-gap-line"></span>

      <p>
        Digital progress starts when
        <strong> every effort has a reason.</strong>
      </p>

      <span className="ds-gap-line"></span>

    </div>

  </div>

</section>


{/* STRATEGY BEFORE EXECUTION */}
<section className="ds-thinking-section">

  <div className="ds-thinking-container">

    {/* HEADER */}
    <div className="ds-thinking-header">

      <span className="ds-thinking-label">
        STRATEGY BEFORE EXECUTION
      </span>

      <h2>
        Before We Ask
        <br />
        <span>“What Should We Do?”</span>
      </h2>

      <div className="ds-thinking-divider">
        <span></span>
        <p>We Ask A Better Question.</p>
        <span></span>
      </div>

      <h3>
        “What Are We Trying To Achieve?”
      </h3>

    </div>


    {/* STRATEGIC QUESTIONS */}
    <div className="ds-thinking-grid">

      <div className="ds-thinking-item">
        <span className="ds-thinking-number">01</span>

        <div className="ds-thinking-content">
          <span className="ds-thinking-category">
            BUSINESS
          </span>

          <h4>
            What are you
            <br />
            trying to achieve?
          </h4>
        </div>
      </div>


      <div className="ds-thinking-item">
        <span className="ds-thinking-number">02</span>

        <div className="ds-thinking-content">
          <span className="ds-thinking-category">
            AUDIENCE
          </span>

          <h4>
            Who are you
            <br />
            trying to reach?
          </h4>
        </div>
      </div>


      <div className="ds-thinking-item">
        <span className="ds-thinking-number">03</span>

        <div className="ds-thinking-content">
          <span className="ds-thinking-category">
            POSITION
          </span>

          <h4>
            Why should they
            <br />
            choose you?
          </h4>
        </div>
      </div>


      <div className="ds-thinking-item">
        <span className="ds-thinking-number">04</span>

        <div className="ds-thinking-content">
          <span className="ds-thinking-category">
            DIGITAL PRESENCE
          </span>

          <h4>
            What is working
            <br />
            and what is missing?
          </h4>
        </div>
      </div>


      <div className="ds-thinking-item">
        <span className="ds-thinking-number">05</span>

        <div className="ds-thinking-content">
          <span className="ds-thinking-category">
            PRIORITIES
          </span>

          <h4>
            What should
            <br />
            happen first?
          </h4>
        </div>
      </div>

    </div>


    {/* CLOSING */}
    <div className="ds-thinking-closing">
      <p>
        The right strategy starts with
        <strong> the right questions.</strong>
      </p>
    </div>

  </div>

</section>


{/* THE SATIMA STRATEGY PROCESS */}
<section className="ds-process-section">

  <div className="ds-process-container">

    {/* HEADER */}
    <div className="ds-process-header">

      <span className="ds-process-label">
        THE SATIMA STRATEGY PROCESS
      </span>

      <h2>
        A Strategy Built
        <br />
        <span>Around Your Business.</span>
      </h2>

      <p>
        From understanding your business to continuously improving what comes next.
      </p>

    </div>


    {/* PROCESS */}
    <div className="ds-process-grid">

      <div className="ds-process-item">
        <span className="ds-process-number">01</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            UNDERSTAND
          </span>

          <h3>Start With The Business.</h3>

          <p>
            We understand your business, audience, objectives and current position.
          </p>
        </div>
      </div>


      <div className="ds-process-item">
        <span className="ds-process-number">02</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            DIAGNOSE
          </span>

          <h3>Find What Is Holding You Back.</h3>

          <p>
            We identify gaps, weaknesses and missed opportunities across your digital presence.
          </p>
        </div>
      </div>


      <div className="ds-process-item">
        <span className="ds-process-number">03</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            PRIORITIZE
          </span>

          <h3>Focus On What Matters First.</h3>

          <p>
            We determine what deserves attention instead of trying to fix everything at once.
          </p>
        </div>
      </div>


      <div className="ds-process-item">
        <span className="ds-process-number">04</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            STRATEGIZE
          </span>

          <h3>Turn Insight Into Direction.</h3>

          <p>
            We create a practical digital roadmap aligned with your objectives.
          </p>
        </div>
      </div>


      <div className="ds-process-item">
        <span className="ds-process-number">05</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            EXECUTE
          </span>

          <h3>Put The Strategy Into Action.</h3>

          <p>
            Where needed, we help turn strategy into websites, marketing, content, SEO, advertising or technology.
          </p>
        </div>
      </div>


      <div className="ds-process-item">
        <span className="ds-process-number">06</span>

        <div className="ds-process-content">
          <span className="ds-process-category">
            IMPROVE
          </span>

          <h3>Keep Moving Forward.</h3>

          <p>
            We measure performance and refine the strategy as your business evolves.
          </p>
        </div>
      </div>

    </div>


    {/* STRATEGY FLOW */}
    <div className="ds-process-flow">

      <div className="ds-process-flow-item">
        <span>STRATEGY</span>
      </div>

      <span className="ds-process-flow-arrow">→</span>

      <div className="ds-process-flow-item">
        <span>STRUCTURE</span>
      </div>

      <span className="ds-process-flow-arrow">→</span>

      <div className="ds-process-flow-item">
        <span>EXECUTION</span>
      </div>

      <span className="ds-process-flow-arrow">→</span>

      <div className="ds-process-flow-item ds-process-flow-final">
        <span>GROWTH</span>
      </div>

    </div>

  </div>

</section>


{/* WHAT WE CAN HELP YOU CLARIFY */}
<section className="ds-clarify-section">

  <div className="ds-clarify-container">

    {/* HEADER */}
    <div className="ds-clarify-header">

      <span className="ds-clarify-label">
        WHAT WE CAN HELP YOU CLARIFY
      </span>

      <h2>
        What Can We Help
        <br />
        <span>You Figure Out?</span>
      </h2>

      <p>
        The right digital decisions start with knowing what
        needs attention, what matters most, and why.
      </p>

    </div>


    {/* CLARITY AREAS */}
    <div className="ds-clarify-list">

      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          01
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            DIGITAL DIRECTION
          </span>

          <h3>
            Where should your business
            <br />
            focus its digital efforts?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>


      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          02
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            MARKETING STRATEGY
          </span>

          <h3>
            Which channels should
            <br />
            you use and why?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>


      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          03
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            WEBSITE & SEO
          </span>

          <h3>
            Is your website helping
            <br />
            or holding you back?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>


      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          04
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            CONTENT & SOCIAL MEDIA
          </span>

          <h3>
            What should you communicate
            <br />
            and to whom?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>


      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          05
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            TECHNOLOGY
          </span>

          <h3>
            Could technology simplify
            <br />
            or improve your operations?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>


      <div className="ds-clarify-item">

        <span className="ds-clarify-number">
          06
        </span>

        <div className="ds-clarify-content">

          <span className="ds-clarify-category">
            PERFORMANCE
          </span>

          <h3>
            What should you measure
            <br />
            to know what is working?
          </h3>

        </div>

        <span className="ds-clarify-arrow">
          →
        </span>

      </div>

    </div>


    {/* CLOSING */}
    <div className="ds-clarify-closing">

      <span className="ds-clarify-line"></span>

      <p>
        Better decisions begin with
        <strong> better clarity.</strong>
      </p>

      <span className="ds-clarify-line"></span>

    </div>

  </div>

</section>



{/* THE DIGITAL DIAGNOSIS */}
<section className="ds-diagnosis-section">

  <div className="ds-diagnosis-container">

    {/* HEADER */}
    <div className="ds-diagnosis-header">

      <span className="ds-diagnosis-label">
        THE DIGITAL DIAGNOSIS
      </span>

      <h2>
        We Look At The
        <br />
        <span>Whole Digital Picture.</span>
      </h2>

      <p>
        Before recommending what to change, we look at how
        the different parts of your digital presence work together.
      </p>

    </div>


    {/* DIAGNOSIS GRID */}
    <div className="ds-diagnosis-grid">

      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          01
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            WEBSITE
          </span>

          <h3>Website</h3>

          <p>
            Visibility <span>•</span> UX <span>•</span> Conversion
          </p>

        </div>

      </div>


      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          02
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            SEARCH
          </span>

          <h3>Search</h3>

          <p>
            SEO <span>•</span> Local Search <span>•</span> Discoverability
          </p>

        </div>

      </div>


      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          03
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            MARKETING
          </span>

          <h3>Marketing</h3>

          <p>
            Channels <span>•</span> Campaigns <span>•</span> Acquisition
          </p>

        </div>

      </div>


      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          04
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            SOCIAL
          </span>

          <h3>Social</h3>

          <p>
            Content <span>•</span> Positioning <span>•</span> Engagement
          </p>

        </div>

      </div>


      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          05
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            TECHNOLOGY
          </span>

          <h3>Technology</h3>

          <p>
            Systems <span>•</span> Automation <span>•</span> Efficiency
          </p>

        </div>

      </div>


      <div className="ds-diagnosis-item">

        <span className="ds-diagnosis-number">
          06
        </span>

        <div className="ds-diagnosis-content">

          <span className="ds-diagnosis-category">
            MEASUREMENT
          </span>

          <h3>Measurement</h3>

          <p>
            KPIs <span>•</span> Data <span>•</span> Performance
          </p>

        </div>

      </div>

    </div>


    {/* CLOSING STATEMENT */}
    <div className="ds-diagnosis-closing">

      <span className="ds-diagnosis-line"></span>

      <p>
        We connect the pieces before recommending
        <strong> what should happen next.</strong>
      </p>

      <span className="ds-diagnosis-line"></span>

    </div>

  </div>

</section>



<section className="ds-why-section">
  <div className="ds-why-container">

    {/* HEADER */}
    <div className="ds-why-header">
      <span className="ds-why-label">WHY SATIMA</span>

      <h2>
        Strategy Without
        <br />
        <span>The Agency Noise.</span>
      </h2>

      <p>
        We believe good strategy should make your next
        decision clearer, not more complicated.
      </p>
    </div>


    {/* PRINCIPLES */}
    <div className="ds-why-grid">

      <div className="ds-why-item">
        <span className="ds-why-number">01</span>

        <div className="ds-why-content">
          <span className="ds-why-category">BUSINESS FIRST</span>

          <h3>
            Start With
            <br />
            <span>Your Business.</span>
          </h3>

          <p>
            We begin with your objectives, not
            a predetermined package.
          </p>
        </div>
      </div>


      <div className="ds-why-item">
        <span className="ds-why-number">02</span>

        <div className="ds-why-content">
          <span className="ds-why-category">PRACTICAL THINKING</span>

          <h3>
            Strategy That
            <br />
            <span>Makes Sense.</span>
          </h3>

          <p>
            Recommendations should work
            in the real world, not just on paper.
          </p>
        </div>
      </div>


      <div className="ds-why-item">
        <span className="ds-why-number">03</span>

        <div className="ds-why-content">
          <span className="ds-why-category">CONNECTED STRATEGY</span>

          <h3>
            Connect The
            <br />
            <span>Digital Pieces.</span>
          </h3>

          <p>
            Your website, marketing, content and
            technology should work together.
          </p>
        </div>
      </div>


      <div className="ds-why-item">
        <span className="ds-why-number">04</span>

        <div className="ds-why-content">
          <span className="ds-why-category">CLEAR PRIORITIES</span>

          <h3>
            Know What
            <br />
            <span>Comes First.</span>
          </h3>

          <p>
            Know what matters now, what can
            wait, and why.
          </p>
        </div>
      </div>

    </div>


    {/* CLOSING */}
    <div className="ds-why-closing">
      <span className="ds-why-line"></span>

      <p>
        Less noise.
        <strong> Better decisions.</strong>
      </p>

      <span className="ds-why-line"></span>
    </div>

  </div>
</section>



<section className="ds-fit-section">
  <div className="ds-fit-container">

    <div className="ds-fit-header">
      <span className="ds-fit-label">WHO IS THIS FOR?</span>

      <h2>
        When Strategy Becomes
        <br />
        <span>The Right Next Step.</span>
      </h2>

      <p>
        Strategy is most valuable when you need clarity
        before making another digital decision.
      </p>
    </div>

    <div className="ds-fit-content">

      <div className="ds-fit-intro">
        <span className="ds-fit-intro-number">01</span>

        <h3>
          You don't need
          <br />
          <span>more activity.</span>
        </h3>

        <p>
          You need to understand what deserves attention,
          what should come first, and where your digital
          efforts should lead.
        </p>
      </div>

      <div className="ds-fit-list">

        <div className="ds-fit-item">
          <span className="ds-fit-number">01</span>
          <p>You're unsure where to invest digitally.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">02</span>
          <p>Your marketing efforts lack a clear system.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">03</span>
          <p>You're launching or repositioning your business.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">04</span>
          <p>Your website isn't delivering enough value.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">05</span>
          <p>You want to strengthen your digital presence.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">06</span>
          <p>You're considering new technology or automation.</p>
        </div>

        <div className="ds-fit-item">
          <span className="ds-fit-number">07</span>
          <p>You need an objective view of what to fix first.</p>
        </div>

      </div>

    </div>

    <div className="ds-fit-closing">
      <span className="ds-fit-line"></span>

      <p>
        If you're asking
        <strong> “What should we do next?”</strong>
        strategy can help.
      </p>

      <span className="ds-fit-line"></span>
    </div>

  </div>
</section>


<section className="ds-outcome-section">
  <div className="ds-outcome-container">

    <div className="ds-outcome-header">
      <span className="ds-outcome-label">WHAT YOU LEAVE WITH</span>

      <h2>
        Clarity You Can
        <br />
        <span>Act On.</span>
      </h2>

      <p>
        The goal is not simply to give you advice.
        It is to give you a clearer understanding of
        what should happen next.
      </p>
    </div>

    <div className="ds-outcome-content">

      <div className="ds-outcome-statement">
        <span className="ds-outcome-number">01</span>

        <h3>
          From uncertainty
          <br />
          <span>to direction.</span>
        </h3>

        <p>
          Depending on your needs and the scope of the
          engagement, your strategy can leave you with
          practical insights you can actually use.
        </p>
      </div>

      <div className="ds-outcome-list">

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">01</span>
          <div>
            <span className="ds-outcome-item-label">DIRECTION</span>
            <h4>A clearer digital direction</h4>
          </div>
        </div>

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">02</span>
          <div>
            <span className="ds-outcome-item-label">INSIGHT</span>
            <h4>Identified opportunities and gaps</h4>
          </div>
        </div>

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">03</span>
          <div>
            <span className="ds-outcome-item-label">PRIORITY</span>
            <h4>Prioritized recommendations</h4>
          </div>
        </div>

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">04</span>
          <div>
            <span className="ds-outcome-item-label">ACTION</span>
            <h4>A practical action plan</h4>
          </div>
        </div>

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">05</span>
          <div>
            <span className="ds-outcome-item-label">MEASUREMENT</span>
            <h4>Relevant KPIs to track</h4>
          </div>
        </div>

        <div className="ds-outcome-item">
          <span className="ds-outcome-item-number">06</span>
          <div>
            <span className="ds-outcome-item-label">INVESTMENT</span>
            <h4>A clearer understanding of where to invest</h4>
          </div>
        </div>

      </div>

    </div>

    <div className="ds-outcome-closing">
      <span className="ds-outcome-line"></span>

      <p>
        Good strategy doesn't leave you with
        <strong> more questions.</strong>
        It gives you a better way forward.
      </p>

      <span className="ds-outcome-line"></span>
    </div>

  </div>
</section>




<section className="faq-section">


  <div className="faq-header">


    <h2>
      Frequently Asked Questions
    </h2>


    <p>
      Find answers to the most common questions about our digital strategy
      and consultation services for businesses in Kenya.
    </p>


  </div>




  <div className="faq-container">

<details className="faq-item" open>


  <summary>
    How much does digital strategy consultation cost?
  </summary>


  <p>
    Our digital strategy consultation is charged based on the time required
    to analyze your business, understand your goals, and provide practical
    recommendations.
  </p>


  <ul>

    <li>
      <strong>Consultation Rate:</strong> KSh 1,000 per hour
    </li>

  </ul>


  <p>
    During the consultation, we review your current digital presence,
    identify growth opportunities, and provide actionable strategies
    to help your business move forward.
  </p>


</details>


    <details className="faq-item">


      <summary>
        What businesses need digital strategy consultation?
      </summary>


      <p>
        Digital strategy consultation is ideal for startups, SMEs, professional
        service providers, e-commerce businesses, and companies looking to
        improve their online visibility and growth.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        What is included in a digital strategy consultation?
      </summary>


      <p>
        Our consultation includes analyzing your current digital presence,
        identifying opportunities, reviewing marketing channels, providing
        recommendations, and creating a practical growth roadmap.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How long does a consultation take?
      </summary>


      <p>
        The consultation duration depends on your business needs and the level
        of analysis required. Most sessions cover your goals, challenges,
        current digital presence, and recommended next steps.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Do you provide marketing recommendations after consultation?
      </summary>


      <p>
        Yes. After analyzing your business, we provide practical recommendations
        covering areas such as SEO, social media marketing, content strategy,
        advertising, and website improvements.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Can you help improve my existing online presence?
      </summary>


      <p>
        Yes. We review your existing website, social media platforms, and
        digital marketing efforts to identify areas that can be improved for
        better visibility and customer engagement.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How do I get started?
      </summary>


      <p>
        Simply contact Satima Technova Solutions for a consultation. We will
        understand your business goals, evaluate your current digital position,
        and recommend the right strategy to help you grow.
      </p>


    </details>



  </div>


</section>

        
<section className="final-cta-section">

  <div className="final-cta-content">

    <span className="final-cta-label">
      START WITH CLARITY
    </span>

    <h2>
      Know Where To
      <br />
      <span>Go Next.</span>
    </h2>

    <p>
      Let's identify what matters, what should come first,
      and where your digital efforts should lead.
    </p>

    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'd%20like%20to%20discuss%20my%20digital%20strategy."
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn"
      onClick={handleCTAClick}
    >
      Talk To A Strategy Expert
      <span>→</span>
    </a>

  </div>

</section>

      </main>
    </>
  );
};

export default DigitalStrategyConsultation;